import {Pagination} from '@store/common/pagination.model';
import {ExecutionStatus} from '@store/operations/executions';
import I18n from '@utils/i18n.utils';

export enum ServiceKindTypeEnum {
  PACKAGE = 'PACKAGE',
  PROCESSING = 'PROCESSING',
  RENTING = 'RENTING',
  PICKUP = 'PICKUP',
  OTHER = 'OTHER',
  VALORISATION = 'VALORISATION',
  CLEANING = 'CLEANING',
  DOCUMENT = 'DOCUMENT',
  POSE_WITHDRAWAL = 'POSE_WITHDRAWAL',
}


export enum ExecutionCreationRule {
  SINGLE_EXECUTION = 'SINGLE_EXECUTION',
  MULTIPLE_EXECUTIONS_SAME_SERVICE_KIND_ID = 'MULTIPLE_EXECUTIONS_SAME_SERVICE_KIND_ID',
  MULTIPLE_EXECUTIONS_OTHER_SERVICE_KIND_ID = 'MULTIPLE_EXECUTIONS_OTHER_SERVICE_KIND_ID',
}

export enum UnitOfMeasure {
  TON = 'TON',
  UNIT = 'UNIT',
  DAY = 'DAY',
  MONTH = 'MONTH',
  KM = 'KM',
  LITER = 'LITER',
  M3 = 'M3',
}

export namespace ExecutionCreationRule {
  export const selectItems = () => [
    {
      label: I18n.t('global.executionCreationRuleOptions.singleExecution'),
      value: ExecutionCreationRule.SINGLE_EXECUTION
    },
    {
      label: I18n.t('global.executionCreationRuleOptions.multipleExecutionsSameService'),
      value: ExecutionCreationRule.MULTIPLE_EXECUTIONS_SAME_SERVICE_KIND_ID
    },
    {
      label: I18n.t('global.executionCreationRuleOptions.multipleExecutionOtherService'),
      value: ExecutionCreationRule.MULTIPLE_EXECUTIONS_OTHER_SERVICE_KIND_ID
    }
  ];
}

export namespace ServiceKindTypeEnum {
  export const selectItems = () => [
    {label: I18n.t('global.serviceKindType.renting'), value: ServiceKindTypeEnum.RENTING},
    {label: I18n.t('global.serviceKindType.pose_withdrawal'), value: ServiceKindTypeEnum.POSE_WITHDRAWAL},
    {label: I18n.t('global.serviceKindType.pickup'), value: ServiceKindTypeEnum.PICKUP},
    {label: I18n.t('global.serviceKindType.processing'), value: ServiceKindTypeEnum.PROCESSING},
    {label: I18n.t('global.serviceKindType.valorisation'), value: ServiceKindTypeEnum.VALORISATION},
    {label: I18n.t('global.serviceKindType.package'), value: ServiceKindTypeEnum.PACKAGE},
    {label: I18n.t('global.serviceKindType.cleaning'), value: ServiceKindTypeEnum.CLEANING},
    {label: I18n.t('global.serviceKindType.document'), value: ServiceKindTypeEnum.DOCUMENT},
    {label: I18n.t('global.serviceKindType.other'), value: ServiceKindTypeEnum.OTHER},
  ];
}

export namespace UnitOfMeasure {
  export const selectItems = () => [
    {label: I18n.t('global.unitOfMeasure.ton'), value: UnitOfMeasure.TON},
    {label: I18n.t('global.unitOfMeasure.unit'), value: UnitOfMeasure.UNIT},
    {label: I18n.t('global.unitOfMeasure.day'), value: UnitOfMeasure.DAY},
    {label: I18n.t('global.unitOfMeasure.month'), value: UnitOfMeasure.MONTH},
    {label: I18n.t('global.unitOfMeasure.km'), value: UnitOfMeasure.KM},
    {label: I18n.t('global.unitOfMeasure.liter'), value: UnitOfMeasure.LITER},
    {label: I18n.t('global.unitOfMeasure.m3'), value: UnitOfMeasure.M3},

  ];
}

export interface ServiceKindsPagination extends Pagination {
  data: ServiceKind[];
}

export type ManageServiceKind = Partial<ServiceKind>

export interface ServiceKindLight {
  id: number;
  kind: string;
  execUnitName1: UnitOfMeasure;
  execUnitName2: UnitOfMeasure;
  kindTranslateKey: string;
  type: ServiceKindTypeEnum;
}

export interface ServiceKind {
  id: number;
  kind: string;
  code: string;
  pctVat: number;
  execUnitName1: UnitOfMeasure;
  execUnitName2: UnitOfMeasure;
  type: ServiceKindTypeEnum;
  kindTranslateKey: string;
  execDefaultStatus: ExecutionStatus;
  executionCreationRule: ExecutionCreationRule;
  autoCreateExecutionFromServiceKinds: number[];
  flatRate: boolean;
  other: boolean;
}
